import { render } from "./CampaignSetup.vue?vue&type=template&id=e66bf294"
import script from "./CampaignSetup.vue?vue&type=script&lang=js"
export * from "./CampaignSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__